<template>
  <div class="flex column" style="width: 100vm" v-title data-title="其他问题">
    <div v-for="(data, index) in list" :key="index">
      <div class="flex column" style="height: 49px; margin: 0 16px" @click="$router.push({name:'QuestionDetail', params: {question: JSON.stringify(data)}})">
        <div class="flex main-space-between cross-center" style="height: 49px;">
          <span>{{index + 1}}.{{data.title}}</span>
          <img src="../assets/arrow_right.png" style="width: 7px; height: 13px">
        </div>
        <div style="background: #EEEEEEFF; height: 1px; width: 100%"></div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "AboutStudentCourse",
    data () {
      return{
        list: [
          {
            title: '课程是什么？',
            detailTexts: [{title: '课程是根据闯关图书延伸的内容，主要目的是教会孩子如何爱上读书以及怎么读书。课程以视频的形式呈现，由知名教师主讲。'}]
          },
          {
            title: '如何购买课程？',
            detailTexts: [{title: '非会员购买单组课程：'},
              {title: '1.单组课程可试看五分钟，试看结束后点击购买完整版；'},
              {title: '2.试看过程中点击屏幕右下角“立即购买”进行购买；'},
              {title: '会员权益兑换单组课程：'},
              {title: '1.阅伴超级会员可以兑换20组课程；'},
              {title: '2.权益到期后，课程将不可观看。'}]
          },
          {
            title: '如何听课？',
            detailTexts: [{title: '1.在阅伴App内，“我的”页面点击“我的课程”后选择要观看的视频即可。'},
              {title: '2.在“首页“点击“阅读课程”，即可进入课程首页。通过切换年级找到想要观看的课程选择即可。'}]
          }
        ]
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/AboutStudentCourse.vue